import React from "react";
import { ApolloProvider, Query } from "react-apollo";
import client from "lib/ApolloClient";
import gql from "graphql-tag";
import { autobind } from "react-decoration";
import qs from "query-string";
import { navigate } from "gatsby";
import ReactLoading from "react-loading";

const getResourceCharactersMapping = gql`
  query getResourceCharactersMapping($searchForm: SearchForm) {
    getResourceCharactersMapping(Input: $searchForm) {
      prefixList
      phoneticList
      strokesList
      languageList
    }
  }
`;

class ResourceCharactersMapping extends React.Component {
  constructor(props) {
    super(props);
    let chineseType = "";
    if (props.search.phonetic) {
      chineseType = "phonetic";
    } else if (props.search.strokes) {
      chineseType = "strokes";
    }
    this.state = {
      auth: props.readerStore.auth,
      searchForm: props.searchForm,
      chineseType: chineseType,
    };
  }

  componentWillReceiveProps(props) {
    if (
      this.state.searchForm.pageType !== props.searchForm.pageType ||
      this.state.searchForm.resourceType !== props.searchForm.resourceType
    ) {
      this.setState({ searchForm: props.searchForm });
    }
  }

  @autobind
  setCharacters(sn, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    params.characters = sn;
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  @autobind
  changeChineseType(type, e) {
    e.preventDefault();
    this.setState({ chineseType: type });
  }

  @autobind
  setAlphabet(alphabet, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = {
      resourceType: search.resourceType,
      pageType: "list",
      alphabet: alphabet,
    };
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  @autobind
  setStrokes(strokes, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = {
      resourceType: search.resourceType,
      pageType: "list",
      strokes: strokes,
    };
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  @autobind
  setPhonetic(phonetic, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = {
      resourceType: search.resourceType,
      pageType: "list",
      phonetic: phonetic,
    };
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  @autobind
  setLanguage(language, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = {
      resourceType: search.resourceType,
      pageType: "list",
      language: language,
    };
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  @autobind
  setAll(e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = {
      resourceType: search.resourceType,
      pageType: "list",
    };
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  render() {
    let { t } = this.props;
    let { chineseType, searchForm } = this.state;
    return (
      <>
        <ApolloProvider client={client.jumperrwdClient}>
          <Query
            query={getResourceCharactersMapping}
            fetchPolicy="network-only"
            variables={{
              searchForm: searchForm,
            }}>
            {({ loading, error, data, refetch }) => {
              if (loading)
                return (
                  <center>
                    <ReactLoading
                      type="cylon"
                      height={"10%"}
                      width={"20%"}
                      color="#005D98"
                    />
                  </center>
                );
              if (error) return `Error!${error.message}`;
              if (data.getResourceCharactersMapping) {
                let {
                  prefixList,
                  phoneticList,
                  strokesList,
                  languageList,
                } = data.getResourceCharactersMapping;
                let isAll = true;
                if (this.props.search.alphabet) {
                  isAll = false;
                }
                if (this.props.search.phonetic) {
                  isAll = false;
                }
                if (this.props.search.strokes) {
                  isAll = false;
                }
                if (this.props.search.language) {
                  isAll = false;
                }
                return (
                  <div className="tab-content">
                    <ul>
                      <li>
                        <div className="subtitle">
                          {t("jumper.common.characters.alphabetical")}
                        </div>
                        <ul className="items_inline">
                          <li>
                            <a
                              tabIndex="0"
                              onClick={this.setAll}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  this.setAll(e);
                                }
                              }}
                              className={isAll ? "active" : ""}>
                              {t("jumper.common.characters.all")}
                            </a>
                          </li>
                          {prefixList &&
                            prefixList.map((prefix) => {
                              return (
                                <li>
                                  <a
                                    tabIndex="0"
                                    onClick={this.setAlphabet.bind(
                                      this,
                                      prefix
                                    )}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        this.setAlphabet(prefix,e);
                                      }
                                    }}
                                    className={
                                      prefix === this.props.search.alphabet
                                        ? "active"
                                        : ""
                                    }>
                                    {prefix}
                                  </a>
                                </li>
                              );
                            })}
                        </ul>
                      </li>
                      {phoneticList && strokesList && (
                        <li>
                          <div className="subtitle">
                            {t("jumper.common.characters.chinese")}
                          </div>
                          <ul className="items_inline">
                            {phoneticList && (
                              <li>
                                <a
                                  tabIndex="0"
                                  onClick={this.changeChineseType.bind(
                                    this,
                                    "phonetic"
                                  )}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      this.changeChineseType("phonetic", e);
                                    }
                                  }}
                                  className={
                                    this.props.search.phonetic ? "active" : ""
                                  }>
                                  {t("jumper.common.characters.phonetic")}
                                </a>
                              </li>
                            )}
                            {strokesList && (
                              <li>
                                <a
                                  tabIndex="0"
                                  onClick={this.changeChineseType.bind(
                                    this,
                                    "strokes"
                                  )}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      this.changeChineseType("strokes", e);
                                    }
                                  }}
                                  className={
                                    this.props.search.strokes ? "active" : ""
                                  }>
                                  {t("jumper.common.characters.stroke")}
                                </a>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {chineseType === "phonetic" && (
                        <li>
                          <ul className="items_inline">
                            {phoneticList &&
                              phoneticList.map((phonetic) => {
                                return (
                                  <li>
                                    <a
                                      tabIndex="0"
                                      onClick={this.setPhonetic.bind(
                                        this,
                                        phonetic
                                      )}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          this.setPhonetic(phonetic, e);
                                        }
                                      }}
                                      className={
                                        phonetic === this.props.search.phonetic
                                          ? "active"
                                          : ""
                                      }>
                                      {t("jumperrwd.phonetic." + phonetic)}
                                    </a>
                                  </li>
                                );
                              })}
                          </ul>
                        </li>
                      )}
                      {chineseType === "strokes" && (
                        <li>
                          <ul className="items_inline">
                            {strokesList &&
                              strokesList.map((strokes) => {
                                return (
                                  <li>
                                    <a
                                      tabIndex="0"
                                      onClick={this.setStrokes.bind(
                                        this,
                                        strokes
                                      )}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          this.setStrokes(strokes, e);
                                        }
                                      }}
                                      className={
                                        strokes === this.props.search.strokes
                                          ? "active"
                                          : ""
                                      }>
                                      {strokes}
                                    </a>
                                  </li>
                                );
                              })}
                          </ul>
                        </li>
                      )}
                      {languageList && (
                        <li>
                          <div className="subtitle">
                            {t("jumper.common.characters.language")}
                          </div>
                          <ul className="items_inline">
                            {languageList.map((language) => {
                              return (
                                <li>
                                  <a
                                    tabIndex="0"
                                    onClick={this.setLanguage.bind(
                                      this,
                                      language
                                    )}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        this.setLanguage(language, e);
                                      }
                                    }}
                                    className={
                                      language === this.props.search.language
                                        ? "active"
                                        : ""
                                    }>
                                    {t("jumperrwd.language.name." + language)}
                                  </a>
                                </li>
                              );
                            })}
                          </ul>
                        </li>
                      )}
                    </ul>
                  </div>
                );
              }
              return "";
            }}
          </Query>
        </ApolloProvider>
      </>
    );
  }
}

export default ResourceCharactersMapping;
